<template>
	<div
			v-if="featureToggles.showAvailableVouchersInBasket && applicationUserLoggedIn && activeUserVouchers.length"
			class="voucher-carousel-wrapper"
	>
		<carousel
				ref="carousel"
				:per-page="calculatePerPage"
				:mouseDrag="true"
				:scrollPerPage="false"
				:centerMode="true"
				:paginationEnabled="false"
				:navigationEnabled="false"
				:navigationPrevLabel="''"
				:navigationNextLabel="''"
		>
			<slide v-for="voucher in activeUserVouchers" :key="voucher.id">
				<VoucherCarouselItem
					:key="voucher.id"
					:voucher="voucher"
					:isVoucherCarouselContext="isVoucherCarouselContext"
					:userVouchers="activeUserVouchers"
					:voucherProducts="voucherProducts"
				/>
			</slide>
		</carousel>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import {Carousel, Slide} from "vue-carousel/src";
import VoucherCarouselItem from "./VoucherCardItem.vue";
import ProductProvider from "../../../../providers/ProductProvider";
import {filterCurrentUserFavoriteProductListByShopId} from "../../../../libraries/utils";
import routeMapper from "../../../../router/routeMapper";
import {pushGTMInternal} from "../../../../integrations/tracking/gtm/pushGtmEvents";
import appConfig from "../../../../appconfig";
import {hasVoucherReachedLimitOnThisDevice} from "../../../../helper/VoucherValidationHelper";

const TimeBox = appConfig.timeBoxImpl.timebox;
const TimeBoxFormats = appConfig.timeBoxImpl.Formats;

export default {
	name: "VoucherCarousel",
	data() {
		return {
			isVoucherCarouselContext: true,
			voucherProducts: []
		};
	},
	components: {
		VoucherCarouselItem,
		Carousel,
		Slide
	},
	mixins: [],
	computed: {
		...mapGetters([
			"userCrmVouchersAndMilestoneRewards",
			"productCatalog",
			"applicationUserLoggedIn",
			"featureToggles",
			"limitedDiscountAssignments"
		]),
		activeUserVouchers() {
			const vouchers = this.userCrmVouchersAndMilestoneRewards.filter(voucher => {
				const voucherDate = voucher.expiryDate;
				if(voucherDate) {
					const isExpired = TimeBox.fromISO(voucherDate).format(TimeBoxFormats.YYYY_MM_DD).exec() < TimeBox.now().format(TimeBoxFormats.YYYY_MM_DD).exec();
					if(isExpired) {
						return false;
					}
				}
				if(hasVoucherReachedLimitOnThisDevice(voucher.voucherId)) {
					return false;
				}
				return voucher.isActive && !voucher.usedAt;
			});
			const redeemedVouchers = this.$store.getters.vouchersRedeemed || [];
			if(this.$store.getters.globalSelectedShop && this.productCatalog && this.productCatalog.products.length) {
				return vouchers.filter(voucher => {
					const mappedProducts = voucher.productPattern.map(productId => ({productId}));
					const validProducts = filterCurrentUserFavoriteProductListByShopId(
						mappedProducts,
						this.productCatalog,
						this.$store.getters.globalSelectedShop.id,
						this.$store.getters.cachedPickupRules
					);
					return Boolean(validProducts && validProducts.length) && !redeemedVouchers.includes(voucher.id);
				});
			}
			return vouchers;
		},
		calculatePerPage() {
			if(this.$route.name === routeMapper.routeNames.fullBasket) {
				if(this.activeUserVouchers.length <= 2) {
					return 2;
				} else {
					return 2.2;
				}
			} else {
				if(this.activeUserVouchers.length === 1) {
					return 1;
				} else {
					return 1.2;
				}
			}
		}
	},
	async created() {
		if(!this.productCatalog || !this.productCatalog.products.length) {
			const productIds = this.activeUserVouchers.map(voucher => voucher.productPattern).flat();
			this.voucherProducts = await ProductProvider.getProducts({productIds});
		}
		if(this.activeUserVouchers.length && this.featureToggles.showAvailableVouchersInBasket) {
			pushGTMInternal(
				"voucher_impression",
				this.$route.name,
				this.$route.path,
				"carousel_vouchers"
			);
		}
	},
	watch: {
		limitedDiscountAssignments() {
			const self = this;
			self.activeUserVouchers;
		}
	}
};
</script>

<style scoped lang="scss">
div.voucher-carousel-wrapper {
	background-color: transparent;
	/deep/ .VueCarousel-slide:not(:first-child) {
		.voucher-card {
			margin-left: 16px;
		}
	}
	&.flex.component-class {
		background-color: transparent;
	}
}
</style>
